<template>
  <div dense flat class="custom__toolbar mb-5 d-flex">
    <v-spacer />
    <v-btn
      @click="$router.push('/car-make/create')"
      outlined
      v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher"
      depressed
      color="primary"
      tile
    >
      <v-icon left>
        mdi-plus
      </v-icon>
      <span>
        ADD NEW
      </span>
    </v-btn>
  </div>
</template>

<script>
export default {
  components: {}
};
</script>

<style lang="scss">
.session-toolbar {
  .v-toolbar__content {
    padding: 0px !important;
  }
}
</style>
